import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "checkbox-component" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "group-checkbox" }
const _hoisted_4 = { class: "checkbox-text" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "checkbox-text" }
const _hoisted_7 = { class: "checkbox-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.typeCheckbox === 'group')
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionGroupCheckbox, (item, i) => {
              return (_openBlock(), _createBlock("label", {
                key: i,
                class: ["checkbox-item text-neutrals-900 text-14 outline-none py-8p px-12p", {
            'checkbox-item-checked': _ctx.isChecked(item.value),
            'checkbox-item-disabled': item.disable
          }]
              }, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: ["checkbox-input", { disabled: item.disable, checked: _ctx.isChecked(item.value) }],
                  value: item.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkedCheckbox = $event)),
                  name: _ctx.nameGroupCheckbox,
                  disabled: item.disable
                }, null, 10, ["value", "name", "disabled"]), [
                  [_vModelCheckbox, _ctx.checkedCheckbox]
                ]),
                _createVNode("span", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "label", { item: item }, () => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ])
                ]),
                _createVNode("span", {
                  class: ["checkmark w-17 h-17 border rounded border border-neutrals-400 bg-white", {
              'checkmark-checked': _ctx.checkedCheckbox,
              'checkmark-disabled': item.disable
            }]
                }, null, 2)
              ], 2))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _withDirectives(_createVNode("label", {
            class: ["checkbox-item text-neutrals-900 text-14 outline-none", {
          'checkbox-item-checked': _ctx.checkedCheckbox,
          'checkbox-item-disabled': _ctx.disabledSingleCheckbox
        }]
          }, [
            (!_ctx.checked)
              ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkedCheckbox = $event)),
                    class: ["checkbox-input", {
              checked: _ctx.checkedCheckbox,
              disabled: _ctx.disabledSingleCheckbox
            }],
                    disabled: _ctx.disabledSingleCheckbox,
                    name: _ctx.nameSingleCheckbox,
                    value: _ctx.valueSingleCheckbox,
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.checkTab = true), ["tab"])),
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.checkTab = false), ["tab"])),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkTab = false))
                  }, null, 42, ["disabled", "name", "value"]), [
                    [_vModelCheckbox, _ctx.checkedCheckbox]
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "label")
                  ]),
                  _createVNode("span", {
                    class: ["checkmark w-17 h-17 border rounded border border-neutrals-400 bg-white", {
              'checkmark-checked': _ctx.checkedCheckbox,
              'checkmark-disabled': _ctx.disabledSingleCheckbox,
              'check-focus': _ctx.checkTab
            }]
                  }, null, 2)
                ])
              : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
                  _createVNode("input", {
                    class: ["checkbox-input", { disabled: _ctx.disabledSingleCheckbox }],
                    disabled: _ctx.disabledSingleCheckbox,
                    name: _ctx.nameSingleCheckbox,
                    value: _ctx.valueSingleCheckbox,
                    type: "checkbox",
                    checked: _ctx.checked,
                    onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.checkTab = true), ["tab"])),
                    onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.checkTab = false), ["tab"])),
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changeValueSingleSelect && _ctx.changeValueSingleSelect(...args)))
                  }, null, 42, ["disabled", "name", "value", "checked"]),
                  _createVNode("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "label")
                  ]),
                  _createVNode("span", {
                    class: ["checkmark w-17 h-17 border rounded border border-neutrals-400 bg-white", {
              'checkmark-disabled': _ctx.disabledSingleCheckbox,
              'check-focus': _ctx.checkTab
            }]
                  }, null, 2)
                ])
          ], 2), [
            [_directive_click_outside, _ctx.closeTab]
          ])
        ]))
  ]))
}